import classnames from 'classnames';
import React from 'react';

export type InputLabelProps = {
    label: string;
    labelStyle?: string;
    textSizeClassName?: string;
    requiredLabel?: boolean;
};

function InputLabel(props: InputLabelProps): React.JSX.Element {
    return (
        <span
            className={classnames(
                'ml-2 mb-6 select-none',
                props.textSizeClassName || 'text-body-12',
                props.labelStyle
            )}>
            {props.label}
            {props.requiredLabel && ' *'}
        </span>
    );
}

export default InputLabel;
